var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { PaymentTarget } from './payment-target.enum.js';
import { PaymentType } from './payment-type.enum.js';
export class CreatePaymentDto {
    paymentTarget;
    paymentType;
    targetId;
    userId;
    connectedStripeAccountId;
    stripeAccountId;
    STRIPE_RUNTIME_ID;
    checkoutSessionId;
    paymentIntentId;
}
__decorate([
    Expose(),
    IsEnum(PaymentTarget),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "paymentTarget", void 0);
__decorate([
    Expose(),
    IsEnum(PaymentType),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "paymentType", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "targetId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "connectedStripeAccountId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "stripeAccountId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "STRIPE_RUNTIME_ID", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "checkoutSessionId", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreatePaymentDto.prototype, "paymentIntentId", void 0);
//# sourceMappingURL=create-payment.dto.js.map